import React, { useState } from "react";
import { RiDeleteBin6Fill } from "react-icons/ri";
import BotonManualHeader from "../../components/BotonManualHeader";
import { FaSearch, FaFileAlt, FaSyncAlt, FaPlus } from "react-icons/fa";
import { MdVisibility } from "react-icons/md";
import { FaFileSignature } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import swal from 'sweetalert2';

import {
  Stack,
  Button,
  Form,
  Table,
  Card,
  Container,
  Row,
  Col,
  Badge,
  OverlayTrigger,
  Tooltip,
  Spinner
} from "react-bootstrap";
import getAllFormularios from "../../functions/getAllFormularios";
import eliminarProductoHome from "../../functions/eliminarProductoHome";

//modales
import ModalAñadir from "../../components/ModalUpload";
import ModalEditar from "../../components/ModalEditarFormularios";
import filtrarDocumentos from "../../functions/filtrarDocumentos";
import getOnboardingDocs from "../../functions/getOnboardingDocs";

import firebaseApp from "../../firebase/credenciales";
import { collection, doc, getFirestore, writeBatch, deleteDoc, getDocs } from 'firebase/firestore';
import { logBusinessAction } from "../../services/AuditService";

const db = getFirestore(firebaseApp);

let dni = "0";
let ano = "0"

function Documentos({ usuario }) {
  const ruc = usuario.ruc;

  // Estados
  const [baseDatos, setBaseDatos] = useState("");
  const [productos, setProductos] = useState([]);
  const [isModalAñadir, setIsModalAñadir] = useState(false);
  const [isModalEditar, setIsModalEditar] = useState(false);
  const [productoEditar, setProductoEditar] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  async function busquedaFormHandler(e) {
    e.preventDefault();
    if (e.target.busqueda.value !== "") {
      setIsLoading(true);
      try {
        dni = e.target.busqueda.value.trim();
        ano = document.getElementById("ano").value;
        let tipo = document.getElementById("tipo").value;

        let todosLosDocumentos = [];
        let baseDatosLocal = "";

        if (tipo === 'Onboarding') {
          let documentosOnboarding = await getOnboardingDocs(db, dni);
          if (ano !== "0") {
            documentosOnboarding = documentosOnboarding.filter(doc => doc.ano.toString() === ano);
          }
          todosLosDocumentos = documentosOnboarding;
          baseDatosLocal = "onboarding";
        } else {
          if (tipo === `reciboHonorarios`) {
            baseDatosLocal = `uploadDocument`;
          } else if (tipo === `ConstanciaFirma`) {
            baseDatosLocal = `firmasComunicado`;
          } else {
            baseDatosLocal = `document`;
          }
          let documentosRegulares = await filtrarDocumentos(tipo, dni, ano, baseDatosLocal, ruc);
          todosLosDocumentos = documentosRegulares;
        }

        setBaseDatos(baseDatosLocal);

        todosLosDocumentos.sort((a, b) => {
          // Prioridad 1: Ordenar por semana (si ambos tienen semana válida)
          if (a.semana && b.semana && a.semana !== "" && b.semana !== "") {
            return a.semana.localeCompare(b.semana);
          }

          // Prioridad 2: Ordenar por fechaDoc (descendente)
          const dateA = a.fechaDoc && typeof a.fechaDoc.toDate === 'function' ? a.fechaDoc.toDate() : (a.fechaDoc ? new Date(a.fechaDoc) : new Date(0));
          const dateB = b.fechaDoc && typeof b.fechaDoc.toDate === 'function' ? b.fechaDoc.toDate() : (b.fechaDoc ? new Date(b.fechaDoc) : new Date(0));

          return dateA - dateB;
        });

        setProductos(todosLosDocumentos);
      } catch (error) {
        console.error("Error al buscar documentos:", error);
        swal.fire({
          title: 'Error',
          text: 'Hubo un error al buscar los documentos',
          icon: 'error'
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Debe ingresar un DNI y seleccionar un año");
    }
  }

  function actualizarEstadoProductos(dbName) {
    getAllFormularios(dbName, ruc).then((productos) => {
      setProductos(productos);
    });
  }

  const handleRowSelection = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter(id => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  const handleDelete = async () => {
    if (!baseDatos) {
      await swal.fire({
        title: 'Error',
        text: 'Debes realizar una búsqueda antes de eliminar.',
        icon: 'error'
      });
      return;
    }

    if (selectedRows.length === 0) {
      await swal.fire({
        title: 'Sin registros seleccionados',
        text: 'Por favor, selecciona al menos un registro para eliminar.',
        icon: 'info',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    const result = await swal.fire({
      title: 'Confirmar eliminación',
      text: `¿Estás seguro de que deseas eliminar ${selectedRows.length} registro(s) seleccionado(s)?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      setIsDeleting(true);
      try {
        const batch = writeBatch(db);

        selectedRows.forEach(rowId => {
          console.log('Eliminando documento con ID:', rowId, 'de la colección:', baseDatos);
          if (rowId && baseDatos) {
            const rowRef = doc(collection(db, baseDatos), rowId);
            batch.delete(rowRef);
          }
        });

        await batch.commit();

        // Actualizar inmediatamente el estado local
        setProductos(prevProductos =>
          prevProductos.filter(producto => !selectedRows.includes(producto.id))
        );

        setSelectedRows([]);
        setSelectAll(false);

        // AUDITORÍA
        try {
          await logBusinessAction("ELIMINACION_DOCUMENTO_MULTIPLE", "GestionDocumentos", {
            cantidadEliminada: selectedRows.length,
            baseDatos: baseDatos
          }, usuario);
        } catch (e) {
          console.warn("No se pudo registrar la auditoría", e);
        }

        await swal.fire({
          title: 'Eliminado',
          text: `${selectedRows.length} registro(s) eliminado(s) correctamente`,
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });

      } catch (error) {
        console.error('Error al eliminar registros:', error);
        await swal.fire({
          title: 'Error',
          text: 'No se pudo eliminar los registros seleccionados.',
          icon: 'error'
        });
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const eliminarDocumentoOnboarding = async (dni, docId) => {
    console.log('Eliminando documento onboarding:', dni, docId);

    if (!dni || !docId) {
      console.error('DNI o docId están vacíos:', { dni, docId });
      swal.fire('Error', 'No se puede eliminar el documento: datos incompletos.', 'error');
      return;
    }

    try {
      const result = await swal.fire({
        title: '¿Estás seguro?',
        text: "No podrás revertir esta acción",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        const docRef = doc(db, `onboarding/${dni}/legajo/${docId}`);
        await deleteDoc(docRef);

        // Actualizar inmediatamente el estado local
        setProductos(prevProductos =>
          prevProductos.filter(producto => producto.id !== docId)
        );

        // Actualizar selectedRows si el elemento eliminado estaba seleccionado
        setSelectedRows(prevSelected =>
          prevSelected.filter(id => id !== docId)
        );

        // AUDITORÍA
        try {
          await logBusinessAction("ELIMINACION_DOCUMENTO_INDIVIDUAL", "GestionDocumentos", {
            documentoId: docId,
            dniAsociado: dni,
            tipo: "onboarding"
          }, usuario);
        } catch (e) {
          console.warn("No se pudo registrar la auditoría", e);
        }

        swal.fire(
          '¡Eliminado!',
          'El documento ha sido eliminado.',
          'success'
        );
      }
    } catch (error) {
      console.error("Error al eliminar documento:", error);
      swal.fire(
        'Error',
        'No se pudo eliminar el documento.',
        'error'
      );
    }
  };

  const eliminarDocumentoIndividual = async (producto) => {
    console.log('Eliminando documento individual:', producto);

    if (!producto || !producto.id || !baseDatos) {
      console.error('Producto, ID o baseDatos están vacíos:', { producto, baseDatos });
      swal.fire('Error', 'No se puede eliminar el documento: datos incompletos.', 'error');
      return;
    }

    try {
      const result = await swal.fire({
        title: '¿Estás seguro?',
        text: "No podrás revertir esta acción",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        await eliminarProductoHome(producto, usuario.email, baseDatos);

        // Actualizar inmediatamente el estado local
        setProductos(prevProductos =>
          prevProductos.filter(p => p.id !== producto.id)
        );

        // Actualizar selectedRows si el elemento eliminado estaba seleccionado
        setSelectedRows(prevSelected =>
          prevSelected.filter(id => id !== producto.id)
        );

        // AUDITORÍA
        try {
          await logBusinessAction("ELIMINACION_DOCUMENTO_INDIVIDUAL", "GestionDocumentos", {
            documentoId: producto.id,
            nombreArchivo: producto.nombre,
            dniAsociado: producto.dni || producto.dni_trabajador || "desconocido",
            tipo: producto.tipo || baseDatos
          }, usuario);
        } catch (e) {
          console.warn("No se pudo registrar la auditoría", e);
        }

        swal.fire(
          '¡Eliminado!',
          'El documento ha sido eliminado.',
          'success'
        );
      }
    } catch (error) {
      console.error("Error al eliminar documento:", error);
      swal.fire(
        'Error',
        'No se pudo eliminar el documento.',
        'error'
      );
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const allRowIds = productos.map(item => item.id);
      setSelectedRows(allRowIds);
    }
    setSelectAll(!selectAll);
  };

  const limpiarBusqueda = () => {
    setProductos([]);
    setSelectedRows([]);
    setSelectAll(false);
    setBaseDatos("");

    // Limpiar formulario
    const dniInput = document.getElementById('busqueda');
    if (dniInput) dniInput.value = '';

    const anoSelect = document.getElementById('ano');
    if (anoSelect) anoSelect.value = new Date().getFullYear().toString();

    const tipoSelect = document.getElementById('tipo');
    if (tipoSelect) tipoSelect.value = 'Boletas de pago';
  };

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium con degradado verde oscuro */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
              borderBottom: "3px solid #f39c12",
            }}
          >
            <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
              <BotonManualHeader usuario={usuario} />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaFileAlt className="me-3" />
                Consulta de Documentos
              </h2>
              <p className="mb-0 opacity-75">
                Busca y gestiona documentos laborales por trabajador
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Modales */}
            <ModalAñadir
              isModalAñadir={isModalAñadir}
              setIsModalAñadir={setIsModalAñadir}
              actualizarEstadoProductos={actualizarEstadoProductos}
              usuario={usuario}
            />
            {productoEditar && (
              <ModalEditar
                isModalEditar={isModalEditar}
                setIsModalEditar={setIsModalEditar}
                actualizarEstadoProductos={actualizarEstadoProductos}
                productoEditar={productoEditar}
                setProductoEditar={setProductoEditar}
                usuario={usuario}
              />
            )}

            {/* Barra superior con acciones */}
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col md={1}>
                    <div
                      className="rounded-3 p-3 text-center"
                      style={{
                        background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        color: "white"
                      }}
                    >
                      <FaSearch size={24} />
                    </div>
                  </Col>
                  <Col md={9}>
                    <h5 className="mb-1 fw-semibold">Búsqueda de Documentos</h5>
                    <p className="text-muted mb-0 small">
                      Busca documentos específicos por DNI, año y tipo de documento
                    </p>
                  </Col>
                  <Col md={2} className="text-end">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Limpiar búsqueda</Tooltip>}
                    >
                      <Button
                        variant="outline-secondary"
                        className="d-flex align-items-center gap-2"
                        onClick={limpiarBusqueda}
                        style={{
                          borderRadius: "10px",
                        }}
                      >
                        <FaSyncAlt size="16px" />
                        Limpiar
                      </Button>
                    </OverlayTrigger>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Formulario de búsqueda */}
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
              <Card.Header
                className="text-white py-3"
                style={{
                  background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                  borderRadius: "15px 15px 0 0"
                }}
              >
                <div className="d-flex align-items-center">
                  <FaSearch className="me-2" />
                  <div>
                    <h5 className="mb-0 fw-semibold">Filtros de Búsqueda</h5>
                    <small className="opacity-75">Ingresa los criterios para buscar documentos</small>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="p-4">
                <Form onSubmit={busquedaFormHandler}>
                  <Row className="g-3 align-items-end">
                    <Col md={2}>
                      <Form.Label className="fw-bold">Año</Form.Label>
                      <Form.Select
                        id="ano"
                        required
                        defaultValue={new Date().getFullYear().toString()}
                        className="form-control-lg"
                        style={{ borderRadius: "10px" }}
                      >
                        <option value="2030">2030</option>
                        <option value="2029">2029</option>
                        <option value="2028">2028</option>
                        <option value="2027">2027</option>
                        <option value="2026">2026</option>
                        <option value="2025">2025</option>
                        <option value="2024">2024</option>
                        <option value="2023">2023</option>
                        <option value="2022">2022</option>
                      </Form.Select>
                    </Col>

                    <Col md={4}>
                      <Form.Label className="fw-bold">Tipo de Documento</Form.Label>
                      <Form.Select
                        id="tipo"
                        required
                        className="form-control-lg"
                        style={{ borderRadius: "10px" }}
                      >
                        <option value="Boletas de pago">BOLETAS DE PAGO</option>
                        <option value="CTS">CTS</option>
                        <option value="Gratificaciones">GRATIFICACIONES</option>
                        <option value="Utilidades">UTILIDADES</option>
                        <option value="Contratos">CONTRATOS</option>
                        <option value="Renta">RENTA DE 5TA</option>
                        <option value="Memorandums">MEMORANDUMS</option>
                        <option value="Onboarding">ONBOARDING</option>
                        <option value="Vacaciones">VACACIONES</option>
                        <option value="Prestamos">PRESTAMOS</option>
                        <option value="Adelantos">ADELANTOS</option>
                        <option value="reciboHonorarios">RECIBO POR HONORARIOS</option>
                        <option value="ConstanciaFirma">CONSTANCIA DE FIRMA</option>
                        <option value="PoliticasLaborales">POLITICA SALARIAL</option>
                        <option value="Ceses">CESES Y LIQUIDACIONES</option>
                        <option value="Otros">OTROS</option>
                      </Form.Select>
                    </Col>

                    <Col md={4}>
                      <Form.Label className="fw-bold">DNI del Trabajador</Form.Label>
                      <Form.Control
                        id="busqueda"
                        type="text"
                        placeholder="Ingrese el DNI (8-9 dígitos)"
                        className="form-control-lg"
                        style={{ borderRadius: "10px" }}
                        maxLength="9"
                        pattern="[0-9]{8,9}"
                      />
                    </Col>

                    <Col md={2}>
                      <Button
                        variant="primary"
                        type="submit"
                        className="w-100 d-flex align-items-center justify-content-center gap-2"
                        size="lg"
                        disabled={isLoading}
                        style={{
                          borderRadius: "10px",
                          background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                          border: "none",
                        }}
                      >
                        <FaSearch size="16px" />
                        {isLoading ? 'Buscando...' : 'Buscar'}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>

            {/* Loading state */}
            {isLoading && (
              <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
                <Card.Body className="p-4">
                  <div className="text-center">
                    <div
                      className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        color: "white"
                      }}
                    >
                      <Spinner animation="border" variant="light" />
                    </div>
                    <h5 className="mb-2">Buscando documentos...</h5>
                    <p className="text-muted mb-0">Por favor espera mientras procesamos la búsqueda</p>
                  </div>
                </Card.Body>
              </Card>
            )}

            {/* Estadísticas */}
            {productos.length > 0 && (
              <Row className="mb-4">
                <Col md={4}>
                  <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                    <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #1e7e34 0%, #20c997 100%)", color: "white", borderRadius: "15px" }}>
                      <h4 className="fw-bold">{productos.filter(p => p.activo).length}</h4>
                      <p className="mb-0">Documentos Activos</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                    <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)", color: "white", borderRadius: "15px" }}>
                      <h4 className="fw-bold">{productos.filter(p => !p.activo).length}</h4>
                      <p className="mb-0">Documentos Inactivos</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                    <Card.Body className="text-center" style={{ background: "linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%)", color: "white", borderRadius: "15px" }}>
                      <h4 className="fw-bold">{productos.length}</h4>
                      <p className="mb-0">Total Encontrados</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}

            {/* Tabla de resultados */}
            {!isLoading && (
              <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "15px" }}>
                <Card.Header
                  className="text-white py-3"
                  style={{
                    background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                    borderRadius: "15px 15px 0 0"
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaFileAlt className="me-2" />
                    <div className="flex-grow-1">
                      <h5 className="mb-0 fw-semibold">Documentos Encontrados</h5>
                      <small className="opacity-75">
                        {productos.length > 0
                          ? `Documentos del trabajador DNI: ${dni}`
                          : "Realiza una búsqueda para ver documentos"}
                      </small>
                    </div>
                    {productos.length > 0 && (
                      <div className="d-flex align-items-center gap-2">
                        <Badge bg="light" text="dark" style={{ fontSize: "0.9rem" }}>
                          {productos.length} documentos
                        </Badge>
                        {selectedRows.length > 0 && (
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={handleDelete}
                            disabled={isDeleting}
                            className="d-flex align-items-center gap-1"
                            style={{ borderRadius: "8px" }}
                          >
                            <RiDeleteBin6Fill size="14px" />
                            {isDeleting ? 'Eliminando...' : `Eliminar (${selectedRows.length})`}
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                </Card.Header>

                <Card.Body className="p-0">
                  {productos.length > 0 ? (
                    <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                      <Table hover responsive className="mb-0" style={{ fontSize: "0.9rem" }}>
                        <thead
                          style={{
                            backgroundColor: "#f8f9fa",
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                          }}
                        >
                          <tr>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '3%' }}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectAll}
                                onChange={handleSelectAll}
                              />
                            </th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '5%' }}>N°</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>Estado</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '6%' }}>Año</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>Mes</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '30%' }}>Nombre</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '6%' }}>Vistas</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '10%' }}>Tipo</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>Ver</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>Firma</th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productos.map((producto, index) => (
                            <tr key={producto.id || `producto-${index}`} style={{ borderBottom: "1px solid #f1f3f4" }}>
                              <td className="text-center py-3 px-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={selectedRows.includes(producto.id)}
                                  onChange={() => handleRowSelection(producto.id)}
                                />
                              </td>
                              <td className="text-center py-3 px-3">
                                <Badge bg="dark" className="px-2 py-1">
                                  {index + 1}
                                </Badge>
                              </td>
                              <td className="text-center py-3 px-3">
                                <Badge bg={producto.activo ? 'success' : 'danger'} className="px-2 py-1">
                                  {producto.activo ? "Activo" : "Inactivo"}
                                </Badge>
                              </td>
                              <td className="text-center py-3 px-3">
                                <Badge bg="info" className="px-2 py-1">
                                  {producto.ano}
                                </Badge>
                              </td>
                              <td className="text-center py-3 px-3">
                                <Badge bg="secondary" className="px-2 py-1">
                                  {producto.mes || producto.periodo || '-'}
                                </Badge>
                              </td>
                              <td className="py-3 px-3">
                                <div className="d-flex align-items-center">
                                  <div
                                    className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                                      color: "white"
                                    }}
                                  >
                                    <FaFileAlt size="14px" />
                                  </div>
                                  <div>
                                    <div className="fw-medium text-dark small">
                                      {producto.nombre.length > 40
                                        ? producto.nombre.substr(0, 40) + "..."
                                        : producto.nombre}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="text-center py-3 px-3">
                                <Badge bg="light" text="dark" className="px-2 py-1">
                                  {producto.contador || 0}
                                </Badge>
                              </td>
                              <td className="text-center py-3 px-3">
                                <Badge
                                  bg="primary"
                                  className="px-2 py-1 small"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {producto.tipo}
                                </Badge>
                              </td>
                              <td className="text-center py-3 px-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Ver documento</Tooltip>}
                                >
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    href={producto.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ borderRadius: "8px" }}
                                  >
                                    <MdVisibility size="16px" />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                              <td className="text-center py-3 px-3">
                                {producto.linkFirmado ? (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ver documento firmado</Tooltip>}
                                  >
                                    <Button
                                      variant="outline-success"
                                      size="sm"
                                      href={producto.linkFirmado}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{ borderRadius: "8px" }}
                                    >
                                      <FaFileSignature size="16px" />
                                    </Button>
                                  </OverlayTrigger>
                                ) : (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Sin firma disponible</Tooltip>}
                                  >
                                    <span>
                                      <FaTimes size="16px" className="text-muted" />
                                    </span>
                                  </OverlayTrigger>
                                )}
                              </td>
                              <td className="text-center py-3 px-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Eliminar documento</Tooltip>}
                                >
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => {
                                      console.log('Producto a eliminar:', producto);
                                      console.log('Base de datos actual:', baseDatos);

                                      if (baseDatos === 'onboarding') {
                                        eliminarDocumentoOnboarding(producto.dni, producto.id);
                                      } else {
                                        eliminarDocumentoIndividual(producto);
                                      }
                                    }}
                                    style={{ borderRadius: "8px" }}
                                  >
                                    <RiDeleteBin6Fill size="14px" />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <div
                        className="bg-light rounded-circle mx-auto mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaFileAlt size={32} className="text-muted" />
                      </div>
                      <h5 className="text-muted mb-2">No hay documentos disponibles</h5>
                      <p className="text-muted mb-0">
                        Realiza una búsqueda ingresando un DNI para ver los documentos disponibles
                      </p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default Documentos;